import { FontSize } from "../../../model/FontSize";

const FONT_SIZE_CHANGE = 'FONT_SIZE/CHANGE';

export default function fontSizeChangeAction (fontsize: FontSize) {
  return {
    type: FONT_SIZE_CHANGE,
    payload: { 
        fontsize: fontsize
     }
  };
}

export { FONT_SIZE_CHANGE };